<template>
  <div>
    <div class="form-panel">
      <div class="form-panel__header">
        <h2 class="titulo-h2">Subir una Factura</h2>
        <center>
          <u>
            <a href="https://lacentral.com.co/politicas-de-registro-de-facturas/" target="_blank" class="seleccionar-etiqueta" style="color: Gray">Leer Política de Registro de Facturas de Compras</a>
          </u>
        </center>
      </div>
      <div class="form-panel__body">
        <div class="form-fields">
          <div v-if="vista == 0" class="form-fields__principal">
            <h2 class="titulo-h3-light">Selecciona la imagen de la factura</h2>
            <div class="form__group form__group-dropzone" :class="{'form__group-invalid': $v.valorFactura.$error, 'form__group-valid': !$v.valorFactura.$invalid}">
              <vue2-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-file-added="vfileAdded" @vdropzone-success="vsuccess" @vdropzone-error="verror" @vdropzone-sending="sendingEvent"/>
            </div>
            <h4 v-if="imagenAgregada && $v.valorFactura.numeric" class="titulo-h4-light">Valor de la Factura: {{ valorFacturaMoneda }}</h4>
            <h4 v-if="imagenAgregada && !$v.valorFactura.numeric" class="titulo-h4-light">Valor de la Factura</h4>
            <div v-if="imagenAgregada" class="form__group" :class="{'form__group-invalid': $v.valorFactura.$error, 'form__group-valid': !$v.valorFactura.$invalid}">
              <i class="icon-field icon-field-coin"></i>
              <label for="valorFactura">Valor</label>
              <input id="valorFactura" type="text" autofocus @blur="$v.valorFactura.$touch()" v-model="valorFactura">
              <div class="form__group-validation" v-if="$v.valorFactura.$dirty">
                <p v-if="!$v.valorFactura.required">Ingresa el valor de la factura.</p>
                <p v-if="!$v.valorFactura.numeric">Ingresa solo números.</p>
                <p v-if="!$v.valorFactura.minValue">La factura debe ser de al menos $5.000.</p>
                <p v-if="!$v.valorFactura.maxValue">La factura no debe ser mayor a $10.000.000.</p>
              </div>
            </div>
            <div class="form__group form__group-register">
              <a v-if="!$v.$invalid" class="waves-effect waves-light m-btn form-fields__navegacion-der" tabindex="0" @click="subirFactura()">Enviar</a>
            </div>
          </div>
          <div class="form-fields__secundario">
            <h2 class="titulo-h3">Ten en cuenta:</h2>
            <v-flex column>
              <div class="ma-2 subheading">- La foto solo debe contener una factura.</div>
              <div class="ma-2 subheading">- Verifica que la foto sea clara y legible.</div>
              <div class="ma-2 subheading">- En la foto deben leerse claramente datos como marca, valor y fecha.</div>
            </v-flex>            
          </div>
        </div>
      </div>
    </div>
    <div v-if="listaFacturas && listaFacturas.length > 0" class="form-panel">
      <div class="form-panel__header">
        <h2 class="titulo-h2">Historial de Facturas</h2>
      </div>
      <v-card>
        <v-list>
          <v-list-group v-for="item in listaFacturas" :key="item.fechaRegistro" no-action>
            <v-list-tile slot="activator">
              <v-list-tile-action>
                <i class="icon-lista" :class="obtenerIconoEstado(item.estado)"></i>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-if="item.observaciones==null" v-text="item.fechaRegistro + ' ' + item.descripcionEstado"></v-list-tile-title>
                <v-list-tile-title v-else v-text="item.fechaRegistro + ' ' + item.descripcionEstado+' '+item.observaciones"></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-avatar>
                <img :src="item.imagen">
              </v-list-tile-avatar>
            </v-list-tile>
            <img :src="item.imagen">
          </v-list-group>
        </v-list>
      </v-card>
    </div>
  </div>
</template>

<script>

import Vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import { required, numeric, minValue, maxValue } from 'vuelidate/lib/validators'
import axios from 'axios'

export default {
  data: function () {
    return {
      imagenAgregada: false,
      valorFactura: null,
      listaFacturas: null,
      dropzoneOptions: {
        //url: 'http://localhost:5000/api/Cliente/SubirFactura',
        //url: 'https://clientes.lacentral.com.co/services/api/Cliente/SubirFactura',
        url: axios.defaults.baseURL+'api/Cliente/SubirFactura',
        thumbnailWidth: 150,
        maxmaxFilesize: 4, // MB
        acceptedFiles: '.jpg,.jpeg,.png',
        maxFiles: 1,
        autoProcessQueue: false,
        dictDefaultMessage: "<i aria-hidden='true' class='icon material-icons' style='font-size: 6rem;'>cloud_upload</i> Selecciona una imagen"
      },
      vista: 0,
      stream: null,
      video: {},
      canvas: {},
      captures: [],
      camaras: [],
      indice: 0
    }
  },
  computed: {
    valorFacturaMoneda() {
      let valor = "$"

      if (!this.valorFactura) {
        return valor += "0"
      }
      else {
        return valor += this.valorFactura.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
    }
  },
  created () {
    this.leerCamaras()
  },
  methods: {
    leerCamaras () {
      navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        devices.forEach(mediaDevice => {
          if (mediaDevice.kind === 'videoinput') {
            this.camaras.push( mediaDevice.deviceId )
          }
        })
      })
    },
    cambiarCamara() {
      this.stream.getTracks().forEach(track => {
        track.stop()
      })

      this.indice++

      if (this.indice > this.camaras.length - 1) {
        this.indice = 0
      }

      this.iniciarCamaraId(this.camaras[this.indice])
    },
    iniciarCamaraId (id) {
      let videoConstraints = {}
      videoConstraints.deviceId = { exact: id }
      let constraints = {
        video: videoConstraints,
        audio: false
      }

      this.video = this.$refs.video;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia(constraints).then(stream => {
          this.vista = 1
          this.stream = stream
          this.video.srcObject = stream
        })
      }
    },    
    iniciarCamara() {
      if (this.camaras.length > 0) {
        this.indice = 0
        this.iniciarCamaraId(this.camaras[0])
      }
    },
    capture() {
      this.canvas = this.$refs.canvas;
      var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 640, 480);
      this.stream.getTracks().forEach(track => {
        track.stop()
      })
      this.vista = 2
    },
    detenerCaptura() {
      this.stream.getTracks().forEach(track => {
        track.stop()
      }) 
      
      this.vista = 0
    },
    enviar () {
      console.log('entra')
      if (this.$v.valorFactura.$invalid) {
        this.$v.valorFactura.$touch()
        return
      }

      var context = this.canvas.getContext("2d")
      let dataURI = this.canvas.toDataURL("image/jpg")

      let archivo = {
        userId: this.$store.getters.userId,
        valorFactura: this.valorFactura,
        data: dataURI,
        extension: 'jpg'
      }
      // Para producción    
      axios.post('api/Cliente/SubirFacturaDataURL', archivo)
           .then(resp => {
             this.exito()
           })
           .catch (err => {
             this.verror()
           })

      // Para pruebas 
      // axios.post('https://localhost:44370/api/Cliente/SubirFacturaDataURL', archivo)
      //      .then(resp => {
      //        this.exito()
      //      })
      //      .catch (err => {
      //        this.verror()
      //      })
    },
    dataURItoBlob(dataURI) {
      
        let byteString
        let mimestring 

        if(dataURI.split(',')[0].indexOf('base64') !== -1 ) {
            byteString = atob(dataURI.split(',')[1])
        } else {
            byteString = decodeURI(dataURI.split(',')[1])
        }

        mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0]

        var content = new Array();
        for (var i = 0; i < byteString.length; i++) {
            content[i] = byteString.charCodeAt(i)
        }

        return new Blob([new Uint8Array(content)], {type: mimestring});
    },
    vfileAdded(file) {
      if (this.vista == 0) {
        this.imagenAgregada = true
      }

      if (this.vista == 2) {
        this.$refs.myVueDropzone.processQueue()
      }
    },
    sendingEvent(file, xhr, formData) {
      formData.append('ValorFactura', this.valorFactura)
      formData.append('UserId', this.$store.getters.userId)
    },
    vsuccess(file, response) {
      this.exito()
    },
    verror(file, message, xhr) {
      this.error()
    },
    subirFactura() {
      this.$refs.myVueDropzone.processQueue()
    },
    obtenerIconoEstado(estado) {
      switch (estado) {
        case 0: return 'icon-lista-revision'
        case 1: return 'icon-lista-aprobado'
        case 2: return 'icon-lista-rechazado'
      }
    },
    exito () {
      this.$store.dispatch('mostrarMensaje',
      {
        imagen: 'emo-happy',
        titulo: 'Factura Cargada',
        contenido: 'Se ha cargado la factura. En unas horas se validará los datos ingresados.',
        boton: {
          ruta: { name: 'subir-factura' },
          etiqueta: 'Subir otra Factura'
        },
        enlace1: {
          ruta: { name: 'home' },
          etiqueta: 'Inicio'
        }
      })
    },
    error () {
      this.$store.dispatch('mostrarMensaje',
      {
        imagen: 'emo-sad',
        titulo: 'No se cargó la factura',
        contenido: 'No se pudo completar el proceso. Revisa que tu archivo sea una imagen .jpg o .png.',
        boton: {
          ruta: { name: 'subir-factura' },
          etiqueta: 'Intentar de Nuevo'
        },
        enlace1: {
          ruta: { name: 'home' },
          etiqueta: 'Inicio'
        }
      })
    }
  },
  components: {
    Vue2Dropzone: Vue2Dropzone
  },
  validations: {
    valorFactura: {
      required,
      numeric,
      minValue: minValue(5000),
      maxValue: maxValue(10000000)
    }
  },
  mounted() {
     axios.post('api/cliente/ConsultarFacturasCliente', { userId: this.$store.getters.userId })
       .then(res => {
         this.listaFacturas = res.data
       })
       .catch(error => {

       })

  }
}
</script>
